import { wvusLogger } from "../helpers";
import getTokenExIframeConfig from "./getTokenExIframeConfig";
import { TokenExIframeConfig } from "../types";

export const queryTokenExConfigOpts = {
  enabled: true,
  staleTime: 10 * 60 * 1000,
  cacheTime: 0,
  retry: 1,
  retryDelay: 200,
  refetchOnMount: true,
  refetchOnWindowFocus: false
};

export async function queryTokenExConfig() {
  try {
    const iframeConfig: TokenExIframeConfig = await getTokenExIframeConfig();

    if (!iframeConfig.authenticationKey) {
      throw new Error("Invalid iframe config. Missing the authenticationKey property");
    }

    return iframeConfig;
  } catch (err) {
    wvusLogger.log(err, wvusLogger.getLogLevelNames().ERROR);
    return Promise.reject(err);
  }
}
